<template>
	<v-container>
		<v-row>
			<v-col class="text-center" cols="12">
				<div class="headline primary--text">TeleRetina - Dashboard</div>
			</v-col>
			<v-col cols="12">
				<v-row dense>
					<v-col
						v-for="item in items"
						:key="item.title"
						cols="6"
						sm="4"
						md="3"
						lg="2"
						style="height: auto"
						class="pa-2"
					>
						<v-hover style="height: 100%">
							<v-card slot-scope="{ hover }" :class="{'primary--text elevation-2': hover}" :to="item.link">
								<v-card-text v-if="item.link" class="text-center pb-0">
									<v-icon dark color="primary" x-large>{{ item.icon }}</v-icon>
								</v-card-text>
								<v-card-text class="text-center primary--text" :class="{'secondary--text': hover}">
									<strong>{{ item.title }}</strong>
								</v-card-text>
							</v-card>
						</v-hover>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	mixins: [
		require("@/mixins/router-mixin").default,
		require("@/mixins/permissions-mixin").default
	],
	data() {
		return {
			allItems: [
				{
					title: "Clinic Info",
					icon: "mdi-hospital-building",
					userTypes: [1, 2],
					link: "/dashboard/clinic-info/"
				},
				{
					title: "Users",
					icon: "mdi-account-group",
					userTypes: [1, 2],
					link: "/dashboard/users/"
				},
				{
					title: "User groups",
					icon: "mdi-account-switch",
					userTypes: [1],
					link: "/dashboard/user-groups"
				},
				{
					title: "Stage & State",
					icon: "mdi-medical-bag",
					userTypes: [1],
					link: "/dashboard/stages-states"
				},
				{
					title: "Diagnosis Questions",
					icon: "mdi-eye-check",
					userTypes: [1, 2],
					link: "/dashboard/diagnosis-questions"
				},
				{
					title: "Statistics",
					icon: "mdi-chart-areaspline",
					userTypes: [1, 2],
					link: "/dashboard/stat/"
				},
				{
					title: "SMS System",
					icon: "mdi-message-settings-variant",
					userTypes: [1, 2],
					link: "/dashboard/sms"
				},
				{
					title: "Finances",
					icon: "mdi-finance",
					userTypes: [1, 2]
					// link: "/dashboard/home/"
				},
				{
					title: "Nationalities",
					icon: "mdi-flag",
					userTypes: [1, 2],
					link: "/dashboard/nationalities"
				},
				{
					title: "My Profile",
					icon: "mdi-account",
					userTypes: [1, 2],
					link: "/dashboard/my-profile/"
				},
				{
					title: "Backup & Restore",
					icon: "mdi-restore-clock",
					userTypes: [1, 2]
					// link: "/dashboard/home/"
				},
				{
					title: "Log",
					icon: "mdi-script-text",
					userTypes: [1]
					// link: "/dashboard/home/"
				}
			]
		};
	},
	computed: {
		items() {
			var userType = this.$store.state.userInfo.UserType || -1;
			var filtered = this.allItems.filter(
				item => item.userTypes.indexOf(userType) != -1
			);

			filtered[0].link += this.clinicId;

			return filtered;
		},
		clinicId() {
			console.log("-----");
			console.log(this.$store.state.userInfo);
			return this.$store.state.userInfo.Clinic;
		}
	}
};
</script>